import { render, staticRenderFns } from "./ReferralCreditLogDatatable.vue?vue&type=template&id=f54961ce"
import script from "./ReferralCreditLogDatatable.ts?vue&type=script&lang=ts&external"
export * from "./ReferralCreditLogDatatable.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports